import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChannelGuide } from '@/lib/schema/channelGuide';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import {
  deleteChannel,
  updateChannelActivatedStatus,
} from '@/lib/api/channelGuide';
import { Switch } from '@/components/ui/switch';
import { useFetchImageUrl } from '@/lib/hooks/useFetchImageUrl';

export const columns: ColumnDef<ChannelGuide>[] = [
  {
    accessorKey: 'image',
    header: '',
    cell: ({ row }) => {
      const image = row.getValue('image');

      if (!image) {
        return null;
      }

      const { data } = useFetchImageUrl(`channel-guides/${image}`);

      return <img src={data} className="h-9 w-16" />;
    },
  },
  {
    accessorKey: 'pnum',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        #
      </div>
    ),
    cell: ({ row }) => <div className="capitalize">{row.getValue('pnum')}</div>,
  },
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Name
      </div>
    ),
    cell: ({ row }) => <div className="capitalize">{row.getValue('name')}</div>,
  },
  {
    accessorKey: 'activated',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Active
      </div>
    ),
    cell: ({ row, table }) => (
      <Switch
        checked={row.getValue('activated')}
        onCheckedChange={(status) =>
          updateChannelActivatedStatus(
            (table.options.meta as any).channelGuideId,
            row.getValue('id'),
            status
          )
        }
      />
    ),
  },
  {
    accessorKey: 'id',
    header: 'Actions',
    cell: ({ row, table }) => (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuItem asChild>
            <Link
              className="cursor-pointer"
              to={`/channel-guides/${(table.options.meta as any).channelGuideId}/channels/${row.getValue('id')}`}
            >
              Edit
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() =>
              deleteChannel(
                (table.options.meta as any).channelGuideId,
                row.getValue('id')
              )
            }
          >
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    ),
  },
];
